import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebaseConfig";
export const getImagenes = async (rutaBase, cantidad) => {
  try {
    const urls = [];

    const total = Number(cantidad) || 0;

    for (let i = 1; i <= total; i++) {
      const ruta = `${rutaBase}/${i}.jpg`;

      try {
        const url = await getDownloadURL(ref(storage, ruta));
        urls.push(url);
      } catch (err) {
        console.warn("No existe imagen:", ruta);
        urls.push(null); // evita romper el render
      }
    }

    return urls;
  } catch (error) {
    console.error("Error getImagenes:", error);
    return [];
  }
};